<template>
  <llp-page
    id="datatable-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-2 m-lg-3">
          <div class="card-body">
            <div>
              <div class="row d-flex align-items-center rental-payment mb-4">
                <div class="col mt-4">
                  <!-- <h4 class="rental-heading">Create Ticket</h4> -->
                  <h4>Create Ticket</h4>

                </div>

                <div class="col d-flex justify-content-end">
                  <llp-button
                    :load-spinner="showaddUserSpinner"
                    classNames="btn-secondary new-btn  d-none d-sm-block"
                    type="button"
                    @click="BackToSupport()"
                  >
                    Back To Support
                  </llp-button>
                  <llp-button
                    :load-spinner="showaddUserSpinner"
                    classNames="btn-secondary new-btn d-block d-sm-none"
                    type="button"
                    @click="BackToSupport()"
                  >
                    Go Back
                  </llp-button>
                </div>
              </div>
              <form>
                <div class="row">
                  <div class="col-lg-6 col-md-12 col-sm-12 mt-4">
                    <llp-label id="subject" :aria-label="BusinessAddress">
                      Subject:
                    </llp-label>
                    <llp-input
                      id="subjectinputid"
                      :placeHolder="'Subject'"
                      v-model="this.newTicket.subject"
                      :errors="validator.newTicket.subject.$errors"
                    ></llp-input>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-lg-3 col-md-6 col-sm-6">
                    <llp-label id="label-priority">Priority</llp-label>
                    <select
                      id="priority"
                      class="form-control select-dropdown"
                      v-model="newTicket.priority"
                    >
                      <option value="" selected disabled>Select</option>
                      <option value="Low">Low</option>
                      <option value="Medium">Medium</option>
                      <option value="High">High</option>
                      <option value="Critical">Critical</option>
                    </select>
                    <div
                      v-if="validator.newTicket.priority.$invalid"
                      class="text-danger"
                    >
                      {{ validator.newTicket.priority.$errors[0]?.$message }}
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-6 col-sm-6">
                    <llp-label id="label-priority" :aria-label="priority">
                      Status
                    </llp-label>
                    <select
                      id="status"
                      class="form-control select-dropdown"
                      v-model="newTicket.status"
                    >
                      <option value="Open">Open</option>
                      <option value="On Hold">On Hold</option>
                      <option value="Closed">Close</option>
                    </select>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-lg-6 col-md-8 col-sm-6">
                    <llp-label id="label-comments" :aria-label="comments">
                      Description:
                    </llp-label>
                    <textarea
                      id="comments"
                      :placeHolder="'Comments'"
                      class="form-control"
                      v-model="newTicket.description"
                    ></textarea>
                    <div
                      v-if="validator.newTicket.description.$invalid"
                      class="text-danger"
                    >
                      {{ validator.newTicket.description.$errors[0]?.$message }}
                    </div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-lg-3 col-md-6 col-sm-6">
                    <llp-label id="subject" :aria-label="BusinessAddress">
                      Attachment:
                    </llp-label>
                    <llp-input
                      id="attachmentinputid"
                      :placeHolder="'Attachment'"
                      type="file"
                      @change="validateFileType"
                      v-model="newTicket.attachment"
                    ></llp-input>
                    <div v-if="invalidFileType" class="text-danger">
                      Only .jpg and .png files are allowed.
                    </div>
                  </div>
                </div>
                <!-- <div class="row mt-2">
              <div class="col-lg-3 col-md-6 col-sm-6">
                <llp-label id="label-date" :aria-label="date"> Date </llp-label>
                <llp-calendar
                  id="start-date"
                  :autoClose="true"
                  :showButtonBar="true"
                  :showIcon="true"
                  selectionMode="single"
                  v-model="newTicket.dateRange"
                   :dateFormat="'dd/mm/yy'" 
                 
                />
              </div>
            
            </div> -->
                <div class="d-flex submit-newcomplaint">
                  <llp-button
                    :loadSpinner="addTicketSpinner"
                    classNames="btn-secondary"
                    @click="addNewTicket"
                  >
                    Submit
                  </llp-button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import { helpers, required } from "@vuelidate/validators";
import ErrorService from "../../../services/error.service";
import { useVuelidate } from "@vuelidate/core";
import NetworkService from "@/services/network.service";
// import NetworkService from "../../../services/network.service.js";

export default {
  setup() {
    const formatDateToModel = (date) => {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };

    return { formatDateToModel, validator: useVuelidate() };
  },
  data() {
    return {
      invalidFileType: false,
      addTicketSpinner: false,
      newTicket: {
        // dateRange: this.formatDateToModel(new Date()),
        priority: "Low",
        status: "Open",
        subject: "",
        description: "",
        attachment: "",
      },
    };
  },
  validations() {
    return {
      newTicket: {
        subject: {
          required: helpers.withMessage("Subject is required.", required),
        },
        priority: {
          required: helpers.withMessage("Priority is required", required),
        },

        description: {
          required: helpers.withMessage("Description is required.", required),
        },
      },
    };
  },
  methods: {
    validateFileType(event) {
      const file = event.target.files[0];
      if (file) {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        if (fileExtension !== "jpg" && fileExtension !== "png") {
          this.invalidFileType = true;
        } else {
          this.invalidFileType = false;
        }
      }
    },
    //     async addNewTicket() {
    //       this.validator
    //         .$validate()
    //         .then(async (isValid) => {
    //           if (!isValid || this.invalidFileType) {
    //             return Promise.reject();
    //           }
    //           const payload = {
    //   subject: this.newTicket.subject,
    //   priority: this.newTicket.priority,
    //   status: this.newTicket.status,
    //   description: this.newTicket.description,
    // };

    //           const Response = await NetworkService.post('support-tickets',payload)
    //           console.log("Response",Response);

    //            this.$refs.toast.show("Successfully ticket is created.")
    //            setTimeout(()=>
    //            {
    //               this.$router.push('/user-support')
    //            },3000)
    //         }).catch(()=>{
    // this.$refs.toast.show(
    //             "Unable to creating the ticket details. Please try again.",
    //             "error"
    //           );
    //         })
    //   },

    async addNewTicket() {
      this.validator
        .$validate()
        .then(async (isValid) => {
          if (!isValid || this.invalidFileType) {
            return Promise.reject();
          }
          this.addTicketSpinner = true;
          const formData = new FormData();
          formData.append("subject", this.newTicket.subject);
          formData.append("priority", this.newTicket.priority);
          formData.append("status", this.newTicket.status);
          formData.append("description", this.newTicket.description);

          const fileInput = document.querySelector("#attachmentinputid");
          const file = fileInput.files[0];
          if (file) {
            formData.append("attachment", file);
          }

          try {
            const newTicketResponseData = await NetworkService.post(
              `support-tickets`,
              formData,
              { headers: { "Content-Type": "multipart/form-data" } }
            );

            this.$refs.toast.show(newTicketResponseData.data.message);
            this.addTicketSpinner = false;
            setTimeout(() => {
              this.$router.push("/user-support");
            }, 1500);
          } catch (error) {
            this.addTicketSpinner = false;
            if (error.message) {
              this.$refs.toast.show(
                "Unable to add the ticket,Please try again.",
                "error"
              );
            } else {
              this.$refs.toast.show(
                ErrorService.getErrorMessages(error),
                "error"
              );
            }
          }
        })
        .catch((error) => {
          this.$refs.toast.show(ErrorService.getErrorMessages(error), "error");
        });
    },
    BackToSupport() {
      this.$router.back();
    },
  },
};
</script>
